export default function UploadFileIco() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.3335 12.0279C16.7107 12.0279 16.2053 12.5334 16.2053 13.1561V15.4126H3.79473V13.1561C3.79473 12.5334 3.28929 12.0279 2.6665 12.0279C2.04372 12.0279 1.53827 12.5334 1.53827 13.1561V17.105C1.53827 17.3752 1.83217 17.6691 2.10239 17.6691H17.8976C18.2384 17.6691 18.4618 17.4107 18.4618 17.105V13.1561C18.4618 12.5334 17.9563 12.0279 17.3335 12.0279ZM7.74355 7.51497H8.87178V12.592C8.87178 13.2148 9.37723 13.7203 10 13.7203C10.6228 13.7203 11.1282 13.2148 11.1282 12.592V7.51497H12.2565C12.6536 7.51497 13.0045 7.56857 13.2262 7.34574C13.4468 7.12404 13.4468 6.76356 13.2262 6.5413L10.4378 3.1617C10.3193 3.04323 10.163 2.99244 10.009 3.0009C9.85447 2.99244 9.6982 3.04323 9.5803 3.1617L6.79188 6.5413C6.57075 6.76356 6.57075 7.12404 6.79188 7.34574C7.01301 7.56857 7.52242 7.51497 7.74355 7.51497Z"
        fill="#6941C6"
      />
    </svg>
  );
}
